const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "17%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "9%"
  },
  {
    key: "avgFrequency",
    zh: "平均频率(Hz)",
    en: "Avg Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "ratedFrequency",
    zh: "上限频率(Hz)",
    en: "Rated Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "mainSpeed",
    zh: "主机转速(%)",
    en: "Main Speed(%)",
    width: "10%",
    tooltip: true
  },
  {
    key: "airFilterElementValue",
    zh: "空滤报警值",
    en: "Air Filter Element Value",
    width: "10%",
    tooltip: true
  },
  {
    key: "airFilterElementRunTime",
    zh: "空滤运行时间",
    en: "Air Filter Element Run Time",
    width: "10%",
    tooltip: true
  },
  {
    key: "percentage",
    zh: "占比",
    en: "Percentage",
    width: "10%"
  }
]

export default columns